module.exports = __webpack_public_path__ + "static/media/global-blue.855b1f48.svg";